import React, { useState, useRef } from 'react';
import { getGalleryUploadUrl } from '../api';

const CATEGORIES = [
  { value: 'flowers', label: 'Flowers' },
  { value: 'vegetables', label: 'Vegetables' },
  { value: 'lawn', label: 'Lawn' },
  { value: 'other', label: 'Other' },
];

export default function AdminGalleryUpload({ token }) {
  const fileInputRef = useRef();
  const [category, setCategory] = useState('flowers');
  const [uploads, setUploads] = useState([]);
  const [dragover, setDragover] = useState(false);
  const [error, setError] = useState('');

  const handleFiles = async (files) => {
    setError('');
    const fileList = Array.from(files).filter(f => f.type.startsWith('image/'));
    for (const file of fileList) {
      const uploadEntry = { name: file.name, status: 'uploading' };
      setUploads(prev => [...prev, uploadEntry]);
      try {
        const { uploadUrl } = await getGalleryUploadUrl({
          category, filename: file.name, contentType: file.type,
        }, token);
        await fetch(uploadUrl, { method: 'PUT', body: file, headers: { 'Content-Type': file.type } });
        setUploads(prev => prev.map(u => u.name === file.name ? { ...u, status: 'done' } : u));
      } catch {
        setUploads(prev => prev.map(u => u.name === file.name ? { ...u, status: 'error' } : u));
      }
    }
  };

  const handleDrop = (e) => { e.preventDefault(); setDragover(false); handleFiles(e.dataTransfer.files); };

  return (
    <div className="form-page">
      <div className="page-head">
        <p className="eyebrow">Admin</p>
        <h1 className="page-title">Gallery upload</h1>
        <p className="page-lede">
          Photographs uploaded here appear automatically in the matching category in the
          &ldquo;From the garden&rdquo; gallery on the home page - no rebuild or redeploy needed.
        </p>
      </div>
      {error && <p className="form-error form-error--banner" role="alert">{error}</p>}

      <div className="panel">
        <div className="form-group">
          <label htmlFor="galleryCategory">Category</label>
          <select id="galleryCategory" value={category} onChange={e => setCategory(e.target.value)}>
            {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
        </div>

        <div
          className={`upload-area ${dragover ? 'dragover' : ''}`}
          onClick={() => fileInputRef.current?.click()}
          onDragOver={e => { e.preventDefault(); setDragover(true); }}
          onDragLeave={() => setDragover(false)}
          onDrop={handleDrop}
          role="button"
          tabIndex={0}
          aria-label="Upload photos by clicking or dragging files here"
        >
          <p><strong>Drag and drop photographs here, or click to browse</strong></p>
          <p className="upload-area__hint">JPG, PNG or WebP</p>
          <input ref={fileInputRef} type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={e => handleFiles(e.target.files)} />
        </div>

        {uploads.length > 0 && (
          <ul className="upload-list">
            {uploads.map((u, i) => (
              <li key={i} className="upload-list__item">
                <span className="upload-list__name">{u.name}</span>
                <span className={`upload-list__status is-${u.status}`}>
                  {u.status === 'done' ? 'Uploaded' : u.status === 'error' ? 'Failed' : 'Uploading'}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
